import PhaseTwo from "components/Participant/CompleteSelfServey/SurveyPhase/PhaseTwo"
import React from "react"

const PhaseTwoPage = () => {
    return (
        <React.Fragment>
            <PhaseTwo />
        </React.Fragment>
    )
    
}
export default PhaseTwoPage
